//@ts-nocheck
import { memo, FunctionComponent } from "react";
import COLORS from "../../theme/Colors";
import { Container, StyledTextField } from "./styles/MaskTextFieldStyles";
import { FieldTitle, Row } from "../../theme/Styles";
import CircularProgress from "@mui/material/CircularProgress";
import CheckRender from "../CheckRender/CheckRender";
import { KeyboardEventHandler } from "react";
import InputMask from "react-input-mask";

const maskPresets = {
  cedula: "999-9999999-9",
  passport: "*******************************",
};

export function localToString(s) {
  if (!s) {
    return "";
  }
  return String(s);
}

export function removeGuionFromString(s) {
  if (!s) {
    return "";
  }
  return localToString(s).replace(/-/g, "");
}

const removeTextFromInputMaskValue = (value) => {
  /*  let NewValue = value.replace(/[^0-9\.]+/g, '');
     return NewValue; */
  let NewValue = removeGuionFromString(value);
  return NewValue;
};

const MaskTextField: FunctionComponent<propTypes> = (props) => {
  return (
    <Container>
      <Row>
        <FieldTitle>{props.title} </FieldTitle>
        <div style={{ width: "5px" }} />
        <CheckRender allowed={props.required}>
          <FieldTitle style={{ color: COLORS.red }}>*</FieldTitle>
        </CheckRender>
      </Row>

      <InputMask
        id={props.id}
        mask={
          props.maskType === "cedula"
            ? maskPresets.cedula
            : maskPresets.passport
        }
        maskChar={null}
        value={props.value}
        disabled={props.disabled}
        onBlur={(e) => {
          props.onBlur({
            target: {
              id: e.target.id,
              value: removeTextFromInputMaskValue(e.target.value),
            },
          });
        }}
        onChange={(e) => {
          props.onChange({
            target: {
              id: e.target.id,
              value: removeTextFromInputMaskValue(e.target.value),
            },
          });
        }}
      >
        {(inputProps) => (
          <StyledTextField
            {...inputProps}
            disabled={props.disabled}
            fullWidth
            variant="outlined"
            placeholder={props.placeholder}
            type={props.type}
            helperText={props.helperText}
            FormHelperTextProps={{ sx: { fontSize: "0.90rem" } }}
            error={props.error}
            /*    InputProps={{
              endAdornment: props.isLoading ? (
                <CircularProgress size="1em" />
              ) : endAdornment !== undefined ? (
                endAdornment
              ) : null,
            }} */
          />
        )}
      </InputMask>
    </Container>
  );
};

export interface propTypes {
  maskType: "cedula" | "passport";
  id: string;
  title?: string;
  placeholder?: string;
  value: string | number | undefined;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEventHandler<HTMLInputElement>) => void;
  type?: string;
  error?: boolean;
  mask?: string;
  unMaskedValue?: boolean;
  hideBorder?: boolean;
  required?: boolean;
  multiline?: boolean;
  minLength?: number;
  maxLength?: number;
  max?: number;
  min?: number;
  disabled?: boolean;
  isLoading?: boolean;
  endAdornment?: any;
  startAdornment?: React.ReactNode;
  helperText?: string | boolean;
  minRows?: number;
  maxRows?: number;
  autoFocus?: boolean;
}

MaskTextField.defaultProps = {
  helperText: " ",
  minRows: 2,
  hideBorder: false,
  autoFocus: false,
};

export default memo(MaskTextField);
